export default __webpack_public_path__ + "static/media/B70.e5312ca0.png";